export default {
  header: 'Diese Woche',
  metrics: {
    points: 'Punkte',
    visits: 'Besuche',
    in_store_sign_ups: 'Im-Store Anmeldungen',
    rewards_redeemed: 'Belohnungen eingelöst',
  },
};
